import { useState } from "react";
import { post } from "../networking/RequestService";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useTaskDelete = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteTask = async (taskId) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevSil",
                gorev: taskId,
                guncelleProfilId: "",
                multiple: false,
            });
            return res.data;
        } catch (res) {
            const errorMessage = apiErrorText(res);
            setError(errorMessage);
            throw errorMessage;
        } finally {
            setLoading(false);
        }
    };

    const bulkDeleteTasks = async (taskIds) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevSil",
                gorev: taskIds,
                guncelleProfilId: "",
                multiple: true,
            });
            return res.data;
        } catch (res) {
            const errorMessage = apiErrorText(res);
            setError(errorMessage);
            throw errorMessage;
        } finally {
            setLoading(false);
        }
    };

    return { deleteTask, bulkDeleteTasks, loading, error };
};

export default useTaskDelete;
